import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getStudentsPypElementRatingsQuery,
  getStudentsPypElementRatingHistoryQuery,
  getCourseUnitPlansBasicDetailsFeedQuery,
} from "./ClassProgressSummaryQuery";

export const getStudentsPypElementRatingsFromCache = ({
  studentIds,
  filtersForRecentMost,
  endDate,
}) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentsPypElementRatingsQuery,
      variables: {
        studentIds,
        filtersForRecentMost,
        endDate,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const getStudentsPypElementRatingHistoryFromCache = params => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getStudentsPypElementRatingHistoryQuery,
      variables: params,
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return queryData;
  else return {};
};

export const getCourseUnitPlansBasicDetailsFeedFromCache = ({ id }) => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getCourseUnitPlansBasicDetailsFeedQuery,
      variables: {
        id,
      },
    });
  } catch (e) {
    return {};
  }

  if (queryData != null) return _.get(queryData, "node", {});
  else return {};
};
